import { EMPTY_SEARCH_PREFERENCE_ENTITY, type SearchPreferenceEntity } from "domain/entity/Common/SearchPreferenceEntity";
import { E_Custom_Dispatch_Event, E_Type_Of_Event, customDispatchEvent } from "helpers/Events";
import { ChargeDetailConstant } from "presentation/constant/ChargeDetailMaintenance/ChargeDetailConstant";
import type { DocumentEnquiryCriteria } from "presentation/constant/DocumentEnquiry/DocumentEnquiryCriteria";
import type { EnabledDocumentEnquiryCriteria } from "presentation/constant/DocumentEnquiry/EnabledDocumentEnquiryCriteria";
import { DocumentPreviewConstant } from "presentation/constant/DocumentPreview/DocumentPreviewConstant";
import { useDocumentEnquiryVM } from "presentation/hook/DocumentEnquiry/useDocumentEnquiryVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useDocumentEnquiryTracked } from "presentation/store/DocumentEnquiry/DocumentEnquiryProvider";
import { OverflowMenuButton } from "presentation/view/components/OverflowMenuButton";
import { useCallback, useEffect, useMemo, useState } from "react";
import { HPHButton, IconButton, OverflowingSubMenu } from "veronica-ui-component/dist/component/core";

export const DocumentEnquiryHeader: React.FC = () => {
    // const [title, setTitle] = useState('INVOICE/CREDIT NOTE SEARCH');
    // const [isList, setIsList] = useState(true);
    // const [isEditCriteria, setIsEditCriteria] = useState(false);
    // const [isDirectory, setIsDirectory] = useState(false);

    // const [isEdit, setIsEdit] = useState(false);
    // const [isShowLessDetail, setIsShowLessDetail] = useState(false);
    // const [isFullScreen, setIsFullScreen] = useState(false);
    // const [documentEnquiryModel, setDocumentEnquiryModel] = useState<DocumentEnquiryModel>(EMPTY_DOCUMENT_ENQUIRY_MODEL);
    const [isShowLegend, setIsShowLegend] = useState<boolean>(false);
    // const [enabelPrint, setEnabelPrint] = useState(false);
    // const [enabelRePrint, setEnabelRePrint] = useState(false);
    const CHARGEDETAIL_CONSTANT = ChargeDetailConstant.Charge;
    const DOCUMENT_PREVIEW_CONSTANT = DocumentPreviewConstant.Title;
    const docEnquiryVM = useDocumentEnquiryVM();
    const messageBarVM = useMessageBarVM();

    const [docEnquiryState] = useDocumentEnquiryTracked();

    // useEffect(() => {
    //     setDocumentEnquiryModel(docEnquiryState)
    // }, [docEnquiryState])

    // Search Criteria Edit
    const handleCriteriaEditClick = useCallback(() => {
        // customDispatchEvent(E_Type_Of_Event.DOCUMENT_ENQUIRY_EVENT, E_Custom_Dispatch_Event.DOCUMENT_ENQUIRY_EDIT_CRITERIA, { isShowRightCriteriaPanel: !isEditCriteria });
        // setIsEditCriteria(!isEditCriteria);
        // setIsDirectory(false);
        docEnquiryVM.handleCriteriaEditClick();
    }, [docEnquiryVM]);

    // Directory icon click
    const handleDirectoryClick = useCallback(() => {
        // if (!isDirectory) {
        //     customDispatchEvent(E_Type_Of_Event.DOCUMENT_ENQUIRY_EVENT, E_Custom_Dispatch_Event.DOCUMENT_ENQUIRY_OPEN_DIRECTORY, {});
        //     setIsDirectory(!isDirectory);
        //     setIsEditCriteria(true);
        // }
        docEnquiryVM.handleDirectoryClick();
    }, [docEnquiryVM]);

    // const handleShowLessDetailClick = useCallback(() => {
    //     customDispatchEvent(E_Type_Of_Event.DOCUMENT_ENQUIRY_EVENT, E_Custom_Dispatch_Event.DOCUMENT_ENQUIRY_DETAIL_SHOW_DETAIL, {});
    //     setIsShowLessDetail(!isShowLessDetail);
    // }, [isShowLessDetail]);

    const handleFullScreen = useCallback(() => {
        customDispatchEvent(E_Type_Of_Event.MODAL_EVENT, E_Custom_Dispatch_Event.MODAL_FULL_SCREEN_MODE, { isFullScreen: !docEnquiryState.isFullScreen, className: 'document-search-modal' });
        // setIsFullScreen(!isFullScreen);
        // setDocumentEnquiryModel({
        //     ...documentEnquiryModel,
        //     isShowLegendButton: !documentEnquiryModel.isShowLegendButton
        // });
        docEnquiryVM.handleFullScreen();
    }, [docEnquiryState.isFullScreen, docEnquiryVM]);

    const handleClose = useCallback(() => {
        localStorage.removeItem(E_Custom_Dispatch_Event.REDIRECT_CHARGE_ITEM_FROM_DELIVERY_SUMMARY);
        customDispatchEvent(E_Type_Of_Event.MODAL_EVENT, E_Custom_Dispatch_Event.MODAL_CLOSE, { showDocumentSearch: false });
    }, []);

    // Back button done
    const handleBackClick = useCallback(() => {
        // customDispatchEvent(E_Type_Of_Event.DOCUMENT_ENQUIRY_EVENT, E_Custom_Dispatch_Event.DOCUMENT_ENQUIRY_MODAL_BACK_TO_LIST, {});
        docEnquiryVM.closeContainerDetail();
    }, [docEnquiryVM]);

    // const handleEditClick = useCallback(() => {
    //     customDispatchEvent(E_Type_Of_Event.DOCUMENT_ENQUIRY_EVENT, E_Custom_Dispatch_Event.DOCUMENT_ENQUIRY_DETAIL_EDIT_MODE_ON, {});
    //     setIsEdit(true);
    // }, []);

    const handleDetailClose = useCallback(() => {
        // if (!isEdit) customDispatchEvent(E_Type_Of_Event.DOCUMENT_ENQUIRY_EVENT, E_Custom_Dispatch_Event.DOCUMENT_ENQUIRY_MODAL_BACK_TO_LIST, {});

        docEnquiryVM.closeContainerDetail();

        // else customDispatchEvent(E_Type_Of_Event.DOCUMENT_ENQUIRY_EVENT, E_Custom_Dispatch_Event.DOCUMENT_ENQUIRY_DETAIL_EDIT_MODE_OFF, {});
        // setIsEdit(false);
    }, [docEnquiryVM]);

    // const handleSaveClose = useCallback(() => {
    //     customDispatchEvent(E_Type_Of_Event.DOCUMENT_ENQUIRY_EVENT, E_Custom_Dispatch_Event.DOCUMENT_ENQUIRY_DETAIL_EDIT_MODE_OFF, {});
    //     setIsEdit(false);
    // }, []);

    const handleSaveSearchPreference = useCallback(() => {
        // customDispatchEvent(E_Type_Of_Event.DOCUMENT_ENQUIRY_EVENT, E_Custom_Dispatch_Event.DOCUMENT_ENQUIRY_PREFERENCE_SAVE_SEARCH, {
        //     currentSearchPreference: documentEnquiryModel.currentSearchPreference,
        //     searchCriteria: documentEnquiryModel.searchCriteria,
        //     enabledSearchCritieria: documentEnquiryModel.enabledSearchCriteria
        // });
        const currentSearchPreference: SearchPreferenceEntity<DocumentEnquiryCriteria, EnabledDocumentEnquiryCriteria> = {
            ...(docEnquiryState.currentSearchPreference ?? EMPTY_SEARCH_PREFERENCE_ENTITY),
            searchCriteria: docEnquiryState.searchCriteria,
            criteriaDirectory: docEnquiryState.enabledSearchCriteria
        }
        docEnquiryVM.saveSearchPreference(currentSearchPreference);
    }, [docEnquiryState.currentSearchPreference, docEnquiryState.enabledSearchCriteria, docEnquiryState.searchCriteria, docEnquiryVM]);

    const handleReprint = useCallback(() => {
        // customDispatchEvent(E_Type_Of_Event.DOCUMENT_ENQUIRY_EVENT, E_Custom_Dispatch_Event.DOCUMENT_ENQUIRY_PRINT, {});
        docEnquiryVM.showPrintPad();
    }, [docEnquiryVM]);

    const preferenceMenu: OverflowingSubMenu[] = useMemo(() => {
        const menuItemArray: OverflowingSubMenu[] = []
        if (docEnquiryState.searchPreferences.length) {
            menuItemArray.push({
                title: 'Open preference',
                submenu: docEnquiryState.searchPreferences?.map(searchPreference => ({
                    title: searchPreference.preferenceName,
                    icon: docEnquiryState.currentSearchPreference?.key === searchPreference.key ? 'hph-icon Icon-masterbookmark-fill' : '',
                    command: () => docEnquiryVM.loadSearchPreference(searchPreference),
                }))
            })
        }

        if (docEnquiryState.currentSearchPreference?.userEmail === docEnquiryState.userEmail) {
            menuItemArray.push({
                title: 'Save preference',
                command: handleSaveSearchPreference,
            })
        }

        menuItemArray.push({
            title: 'Save as new preference...',
            command: () => docEnquiryVM.openSaveNewConfirmModal(),
        });

        const ownDashboards = docEnquiryState.searchPreferences?.filter((searchPreference) => searchPreference.userEmail === docEnquiryState.userEmail)
        if (ownDashboards.length) {
            menuItemArray.push({
                title: 'Delete preference...',
                command: () => docEnquiryVM.openDeleteConfirmModal(),
            })
        }

        return menuItemArray;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [docEnquiryState.searchPreferences, docEnquiryState.currentSearchPreference, docEnquiryState.searchCriteria, docEnquiryState.enabledSearchCriteria,
    docEnquiryState.userEmail, handleSaveSearchPreference]);

    // const onDocumentEnquiryChange = (e: any) => {
    //     switch (e.detail.action) {
    //         case E_Custom_Dispatch_Event.DOCUMENT_ENQUIRY_EDIT_CRITERIA_BACK:
    //             setIsEditCriteria(e.detail.data.isEdit);
    //             setEnabelPrint(e.detail.data.enablePrint);
    //             setEnabelRePrint(e.detail.data.enabelRePrint);
    //             setDocumentEnquiryModel(prev => ({ ...prev, selectedRows: e.detail.data.selectedRows }));
    //             break;
    //         case E_Custom_Dispatch_Event.DOCUMENT_ENQUIRY_HIDE_RIGHT_PANEL:
    //             setIsEditCriteria(true);
    //             setIsDirectory(e.detail.data.isDirectory || false);
    //             break;
    //         case E_Custom_Dispatch_Event.DOCUMENT_ENQUIRY_PREFERENCE_GET:
    //             setDocumentEnquiryModel(e.detail.data.docEnqModel);
    //             break;
    //         case E_Custom_Dispatch_Event.DOCUMENT_ENQUIRY_PREFERENCE_CURRENT_UPDATE:
    //             setDocumentEnquiryModel(prev => ({ ...prev, currentSearchPreference: e.detail.data.currentSearchPreference }));
    //             break;
    //         case E_Custom_Dispatch_Event.DOCUMENT_ENQUIRY_DETAIL_SHOW:
    //             //setTitle('DOCUMENT DETAILS');
    //             setTitle('INVOICE/CREDIT NOTE DETAILS');
    //             setIsList(false);
    //             e.detail.data.isFullScreen && handleFullScreen();
    //             break;
    //         case E_Custom_Dispatch_Event.DOCUMENT_ENQUIRY_DETAIL_HIDE:
    //             setTitle('INVOICE/CREDIT NOTE SEARCH');
    //             setIsList(true);
    //             break;
    //         case E_Custom_Dispatch_Event.DOCUMENT_ENQUIRY_ENABLE_PRINT:
    //             setEnabelPrint(e.detail.data.enablePrint)
    //             setEnabelRePrint(e.detail.data.enableRePrint)
    //             setDocumentEnquiryModel(prev => ({ ...prev, selectedRows: e.detail.data.selectedRows }));
    //             break;
    //     }
    // }

    // useEffect(() => {
    //     customEventListener(E_Type_Of_Event.DOCUMENT_ENQUIRY_EVENT, onDocumentEnquiryChange);
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);

    const handlePreviewDoc = useCallback(async (isSupporting: boolean, isDownload: boolean, exportType: string = "PDF") => {
        //return docEnquiryVM.onPreview(documentEnquiryModel.selectedRows, isSupporting, isDownload);
        await docEnquiryVM.onPreview(docEnquiryState.selectedRows, isSupporting, isDownload, exportType).then((data) => {
            if (data && data["previewReportFail"]) {
                messageBarVM.showError(data["previewReportFail"], true);
            }
        });
    }, [docEnquiryState.selectedRows, docEnquiryVM, messageBarVM]);


    const memoInvPrevMenu = useMemo(() => {
        return [
            {
                title: DOCUMENT_PREVIEW_CONSTANT.PREVIEW_DOC,
                disabled: false,
                command: () => {
                    handlePreviewDoc(false, false);
                }
            },
            {
                title: DOCUMENT_PREVIEW_CONSTANT.DOWNLOAD_DOC,
                disabled: false,
                command: () => {
                    handlePreviewDoc(false, true);
                }
            },
            {
                title: DOCUMENT_PREVIEW_CONSTANT.PREVIEW_SUP,
                disabled: false,
                command: () => {
                    handlePreviewDoc(true, false);
                }
            },
            {
                title: DOCUMENT_PREVIEW_CONSTANT.DOWNLOAD_SUP,
                disabled: false,
                /*command: () => {
                    handlePreviewDoc(true, true);
                },*/
                submenu: [
                    {
                        title: DocumentPreviewConstant.FileType.PDF,
                        disabled: false,
                        command: () => {
                            handlePreviewDoc(true, true, DocumentPreviewConstant.FileType.PDF);
                        }
                    },
                    {
                        title: DocumentPreviewConstant.FileType.XLS,
                        disabled: false,
                        command: () => {
                            handlePreviewDoc(true, true, DocumentPreviewConstant.FileType.XLS);
                        }
                    }
                ]
            }
        ]
    }, [DOCUMENT_PREVIEW_CONSTANT.DOWNLOAD_DOC, DOCUMENT_PREVIEW_CONSTANT.DOWNLOAD_SUP, DOCUMENT_PREVIEW_CONSTANT.PREVIEW_DOC, DOCUMENT_PREVIEW_CONSTANT.PREVIEW_SUP, handlePreviewDoc])

    const overFlowMenu = useMemo(() => <OverflowMenuButton icon='Icon-bookmark' navigationList={preferenceMenu} />, [preferenceMenu]);

    function addLegendToParent(pDivId: string, cDivId: string, headerBox: string) {
        const timer = setInterval(() => {
            const pDiv = document.querySelector(pDivId);
            const cDiv = document.querySelector(cDivId);
            const box = document.querySelector(headerBox);
            const cls: string = cDiv?.getAttribute('class')?.toString() || '';

            if (cls.indexOf('added') >= 0) clearInterval(timer);

            if (pDiv && cDiv && box && cls.indexOf('added') < 0) {
                const pos = pDiv?.getBoundingClientRect();
                const boxPos = box?.getBoundingClientRect();
                cDiv.setAttribute('class', `${cls} added`);
                cDiv.setAttribute('style', `left:${pos && (pos.left - (boxPos?.width ?? 0) * 0.38)}px;top:${boxPos && (boxPos.top + 10)}px;`);
            }
        }, 200);
    }

    useEffect(() => {
        addLegendToParent('#Icon-help-charge-detail-table', '#charge-detail-legend', '#charge-data-search-header-box');
    }, [isShowLegend, docEnquiryState.isFullScreen, docEnquiryState.isShowLegendButton]);

    const handleLegend = useCallback(() => {
        setIsShowLegend(!isShowLegend);
    }, [isShowLegend]);

    const getListHeader: JSX.Element = useMemo(() => {
        return <>
            <div id="charge-data-search-header-box" className="md-header-box">
                <span className="md-header-title" style={{ flexGrow: 1 }}>{docEnquiryState.title}</span>
                {/* <div className="md-header-option" style={{ flexGrow: 0 }}>
                    {(docEnqModel.isShowLegendButton) && <IconButton id="Icon-help-charge-detail-table" fileName='Icon-help' size='medium' toolTipText={'Legend'} toolTipArrow={false} onClick={handleLegend} />}
                </div> */}
                <div className="md-header-option" style={{ flexGrow: 0, justifyContent: "space-between", flexShrink: 0 }}>
                    {docEnquiryState.enablePrint && <OverflowMenuButton disabled={false} buttonLabel={"Preview"} navigationList={memoInvPrevMenu} />}
                    {docEnquiryState.enablePrint && docEnquiryState.enableReprint && <HPHButton label={'Reprint'} size={'Small'} theme={'Primary'} onClick={handleReprint} />}
                    {docEnquiryState.isEditCriteria && <IconButton fileName='Icon-pen' tooltipDisable={false} size="medium" onClick={handleCriteriaEditClick} toolTipText='Edit Criteria' />}
                    {!docEnquiryState.isEditCriteria && <IconButton fileName='Icon-directory' tooltipDisable={false} size="medium" onClick={handleDirectoryClick} toolTipText="Directory" enabled={docEnquiryState.isDirectory} />}
                    {<div style={{ width: "32px", height: "32px" }}>{overFlowMenu}</div>}
                </div>
            </div>
            <div className={`md-header-action`} style={{ width: '75px' }}>
                <IconButton fileName={docEnquiryState.isFullScreen ? 'Icon-minimise' : 'Icon-enlarge'} tooltipDisable={false} toolTipText={!docEnquiryState.isFullScreen ? 'Maximise' : 'Restore'} size="medium" onClick={handleFullScreen} />
                <IconButton fileName="Icon-cross" toolTipText="Close" tooltipDisable={false} size="medium" onClick={handleClose} />
            </div>
            {isShowLegend && <div id='charge-detail-legend' className='detail-legend'>
                <ul>
                    <li><p className='first'><span>{CHARGEDETAIL_CONSTANT.CHARGE_DTL_STATE_LEGEND}</span></p><IconButton fileName="Icon-cross-small" size="small" tooltipDisable={true} onClick={handleLegend} /></li>
                    <li><p className='red'><span>{CHARGEDETAIL_CONSTANT.STATE_RED}</span></p></li>
                    <li><p className='grey'><span>{CHARGEDETAIL_CONSTANT.STATE_GREY}</span></p></li>
                    <li><p className='green'><span>{CHARGEDETAIL_CONSTANT.STATE_GREEN}</span></p></li>
                    <li><p className='blue'><span>{CHARGEDETAIL_CONSTANT.STATE_BLUE}</span></p></li>
                </ul>
            </div>}
        </>
    }, [docEnquiryState.title, docEnquiryState.enablePrint, memoInvPrevMenu, docEnquiryState.enableReprint, handleReprint, docEnquiryState.isEditCriteria,
        handleCriteriaEditClick, handleDirectoryClick, overFlowMenu, docEnquiryState.isFullScreen, handleFullScreen, handleClose, isShowLegend,
    CHARGEDETAIL_CONSTANT.CHARGE_DTL_STATE_LEGEND, CHARGEDETAIL_CONSTANT.STATE_RED, CHARGEDETAIL_CONSTANT.STATE_GREY, CHARGEDETAIL_CONSTANT.STATE_GREEN,
    CHARGEDETAIL_CONSTANT.STATE_BLUE, handleLegend, docEnquiryState.isDirectory]);

    const getDetailHeader: JSX.Element = useMemo(() => {
        return <>
            <div className="md-header-box">
                <span className="md-header-title" style={{ flexGrow: 1 }}>
                    {docEnquiryState.isShowContainerDetail && <IconButton fileName='Icon-arrow-left' toolTipText='Back' toolTipPlacement="right" onClick={handleBackClick} />}
                    <span>{docEnquiryState.title}</span>
                </span>
                {/* <div className="md-header-option" style={{ flexGrow: 0 }}>
                    {!isEdit && <IconButton fileName='Icon-pen' tooltipDisable={false} size="medium" onClick={handleEditClick} toolTipText='Edit' />}

                    {isShowLessDetail && <IconButton fileName='Icon-minus' size="medium" onClick={handleShowLessDetailClick} toolTipText='Less Details' />}
                    {!isShowLessDetail && <IconButton fileName='Icon-move-updown' size="medium" onClick={handleShowLessDetailClick} toolTipText='More Details' />}
                </div> */}
            </div>
            <div className={`md-header-action`} style={{ width: (docEnquiryState.isEdit ? '106px' : '75px') }}>
                {/* <IconButton fileName="Icon-cross" toolTipText="Close" tooltipDisable={false} size="medium" onClick={handleClose} /> */}
                {/*isEdit && <IconButton fileName='Icon-tick' size="medium" onClick={handleSaveClose} toolTipText='Save' />*/}
                <IconButton fileName={docEnquiryState.isFullScreen ? 'Icon-minimise' : 'Icon-enlarge'} tooltipDisable={false} toolTipText={!docEnquiryState.isFullScreen ? 'Maximise' : 'Restore'} size="medium" onClick={handleFullScreen} />
                <IconButton fileName='Icon-cross' size="medium" onClick={handleDetailClose} toolTipText='Close' />
            </div>
        </>
    }, [docEnquiryState.isShowContainerDetail, docEnquiryState.title, docEnquiryState.isEdit, docEnquiryState.isFullScreen, handleBackClick, handleFullScreen, handleDetailClose]);

    if (docEnquiryState.isList) return getListHeader;

    return getDetailHeader;
}